import type { GeneralConfig } from '@shared/types/Config';

export const landUseFactorConfig: GeneralConfig = {
    sortFieldMap: {
        'landuse_type.data.name': 'landuse_types|name',
    },
};
